import { Button } from 'common-front/src/designSystem/components/button';
import { CheckboxText, ICheckboxState } from 'common-front/src/designSystem/components/checkbox';
import { Modal } from 'common-front/src/designSystem/components/modal/modal';
import { Select } from 'common-front/src/designSystem/components/select/select';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { ExportFormat } from 'common/src/generated/types';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';

interface IFileExportModalProps {
    isOpen: boolean;
    showIncludeFiles: boolean;

    onClose(): void;
    requestExport(format: ExportFormat, includeFiles: boolean): void;
}

export const FileExportModal = (props: IFileExportModalProps) => {
    const translate = useTranslate();
    const [format, setFormat] = React.useState(ExportFormat.Excel);
    const [includeFiles, setIncludeFiles] = React.useState<ICheckboxState>('unchecked');
    const onExport = () => {
        props.requestExport(format, includeFiles === 'checked');
    };

    return (
        <Modal.Root isOpen={props.isOpen} onClose={props.onClose}>
            <Modal.Portal>
                <Modal.Header icon="file-xls" subtitle={translate('exporter_votre_28801')}>
                    {translate('exporter_vos_me_10045')}
                </Modal.Header>
                <Modal.Content gap="3">
                    <Box font="gray800 textMd medium">
                        {translate('parameters_de_votre_export')}
                    </Box>

                    <Flex direction="column" gap="5">
                        <Select
                            label={translate('format_de_lexport')}
                            value={format}
                            onChange={setFormat}
                        >
                            <option value={ExportFormat.Excel}>Excel (.xslx)</option>
                            <option value={ExportFormat.Csv}>CSV (.csv)</option>
                        </Select>

                        {props.showIncludeFiles && (
                            <CheckboxText state={includeFiles} onClick={setIncludeFiles}>
                                {translate('inclure_dans_l_65554')}
                            </CheckboxText>
                        )}
                    </Flex>
                </Modal.Content>
                <Modal.Buttons>
                    {() => (
                        <Button
                            onClick={() => {
                                onExport();
                                props.onClose();
                            }}
                        >
                            {translate('recevoir_l_expo_53392')}
                        </Button>
                    )}
                </Modal.Buttons>
            </Modal.Portal>
        </Modal.Root>
    );
};
